import React from "react";
import * as PropTypes from "prop-types";
import MosaicChart from "../../chart/MosaicChart";

const GniGroupBySectorChart = props => (
  <MosaicChart
    ref={props.innerRef}
    xAxisTitle="Share by GNI Group"
    yAxisTitle="Share by Sector"
    series={props.data}
    reversedStacks={props.reversedStacks}
    legendPosition="right"
    legendWidth={props.legendWidth}
    tooltipFormatter={props.tooltipFormatter}
  />
);

GniGroupBySectorChart.propTypes = {
  data: PropTypes.array.isRequired,
  reversedStacks: PropTypes.bool,
  legendWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tooltipFormatter: PropTypes.func
};

export default React.forwardRef((props, ref) => (
  <GniGroupBySectorChart innerRef={ref} {...props} />
));
